import { render, staticRenderFns } from "./viewMore.vue?vue&type=template&id=95bdda66&scoped=true"
import script from "./viewMore.vue?vue&type=script&lang=js"
export * from "./viewMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bdda66",
  null
  
)

export default component.exports